import { type ChatMessage, type AgentPhase } from "../hooks/useSpaceAgent";
import SpaceAgentChat from "./SpaceAgentChat";
import "../space-live.css";

type Props = {
  messages: ChatMessage[];
  agentPhase: AgentPhase;
  isRecording: boolean;
  sendMessage: (text: string) => void;
};

export default function SpaceAgentPanel({
  messages,
  agentPhase,
  isRecording,
  sendMessage,
}: Props) {
  return (
    <div
      className="w-72 flex flex-col shrink-0"
      style={{ margin: 12, marginBottom: 0, marginLeft: 0 }}
    >
      <div className="et-live-chrome flex-1 min-h-0 flex flex-col bg-white rounded-[11px] overflow-hidden shadow-lg">
        <SpaceAgentChat
          messages={messages}
          agentPhase={agentPhase}
          isRecording={isRecording}
          sendMessage={sendMessage}
        />
      </div>
    </div>
  );
}
